import { singleton, inject } from "tsyringe";

// entities
import { UserBehavior } from "@/entities/user/models/behaviors/UserBehavior";
import type { UserDto } from "@/entities/user/models/dtos";

// features
import type { CommonReadOnlyInformationInputValue } from "@/features/pending-registration/models/interface";

@singleton()
export class ReadOnlyInputFormConverter {
    constructor(
        @inject(UserBehavior)
        private readonly userBehavior: UserBehavior,
    ) {}

    public convert(dto: UserDto) {
        const convertedUserDto: CommonReadOnlyInformationInputValue = {
            id: dto.id,
            type: this.userBehavior.mappingUserTypeInString(dto),
            name: dto.name,
            email: dto.email,
            birthday: dto.birthday,
            phone: {
                countryCode: "+" + String(dto.phoneNumber.countryCode),
                subscriberNumber: dto.phoneNumber.subscriberNumber,
            },
            location: dto.location.name,
        };

        return convertedUserDto;
    }
}
